module.exports = __webpack_public_path__ + "images/caf17a380a42ae3056a4e167d40687f6.svg";